import { render, staticRenderFns } from "./PYFA.vue?vue&type=template&id=490d999c"
import script from "./PYFA.vue?vue&type=script&lang=js"
export * from "./PYFA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports